function Footer() {
    return (
        <div className="text-center bg-black">
            <p className="py-2 text-gray">hackX 2022 - All Rights reserved.</p>
        </div>
    );
}

export default Footer;